import { Route, Routes } from "react-router-dom";
import Profile from "../Pages/Auth/Profile";
import ListCourses from "../Pages/Courses/ListCourses";
import Dashboard from "../Pages/Dashboard/Dashboard";
import ListOperators from "../Pages/Operators/ListOperators";
import ManageOperators from "../Pages/Operators/ManageOperators";
import ListSchools from "../Pages/Schools/ListSchools";
import Variables from "../Pages/Settings/DashboardVariables/Variables";
import ListRoles from "../Pages/Settings/Roles/ListRoles";
import ManageRoles from "../Pages/Settings/Roles/ManageRoles";
import Settings from "../Pages/Settings/Settings";
import ExecuteAccessLogs from "../Pages/Settings/UploadCanvasAccessCoursesLog/ExecuteAccessLogs";
import ExecuteCanvasCourses from "../Pages/Settings/UploadCanvasCourses/ExecuteCanvasCourses";
import ExecuteStudentsCompentency from "../Pages/Settings/UploadCanvasStudentsCompentency/ExecuteStudentsCompentency";
import ExecuteCanvasUserLogin from "../Pages/Settings/UploadCanvasUserLoginLog/ExecuteCanvasUserLogin";
import ExecuteCanvasUsers from "../Pages/Settings/UploadCanvasUsers/ExecuteCanvasUsers";
import UploadEsisStudents from "../Pages/Settings/UploadEsisStudents";
import UploadEsisTeachers from "../Pages/Settings/UploadEsisTeachers";
import UsersList from "../Pages/Settings/UsersList/UserList";
import ListStudents from "../Pages/Students/ListStudents";
import UploadOperatorCSLP from "../Pages/Settings/UploadOperatorCSLP/UploadOperatorCSLP";
import ChangePassword from "../Pages/Auth/ChangePassword";
import SubAccounts from "../Pages/Settings/CanvasSyncConfigurations/APISyncData/SubAccounts";
import ListTeachers from "../Pages/Teachers/ListTeachers";
import CSLP from "../Pages/Settings/CanvasSyncConfigurations/SyncCSLP/CSLP";
import SyncCourses from "../Pages/Settings/CanvasSyncConfigurations/APISyncData/SyncCourses";
import SyncUser from "../Pages/Settings/CanvasSyncConfigurations/APISyncData/SyncUsers/SyncUsers";
import DeleteSessions from "../Pages/Settings/DeleteSessions/DeleteSessions";
import SyncSettings from "../Pages/Settings/CanvasSyncConfigurations/SyncSettings";
import SyncTerms from "../Pages/Settings/CanvasSyncConfigurations/SyncTerms";
import Gradebook from "../Pages/Gradebook/Gradebook";
import Assignments from "../Pages/Courses/Assignments";
import Grades from "../Pages/Courses/Grades";
import Reports from "../Pages/Reports/Reports";

const PrivateRoutes = (props) => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={<Dashboard userPermissions={props.userPermissions} />}
        />
        <Route
          path="/ChangePassword"
          element={<ChangePassword userPermissions={props.userPermissions} />}
        />
        <Route
          path="/Dashboard"
          element={<Dashboard userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Profile"
          element={<Profile userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Courses"
          element={<ListCourses userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Courses/assignments/:id"
          element={<Assignments userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Courses/grades/:id"
          element={<Grades userPermissions={props.userPermissions} />}
        />

        <Route
          path="/gradebook"
          element={<Gradebook userPermissions={props.userPermissions} />}
        />

        <Route
          path="/reports"
          element={<Reports userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Students"
          element={<ListStudents userPermissions={props.userPermissions} />}
        />
        <Route
          path="/Teachers"
          element={<ListTeachers userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Settings/DataSync/CSLP"
          element={<CSLP userPermissions={props.userPermissions} />}
        />
        <Route
          path="/Settings/Operators"
          element={<ListOperators userPermissions={props.userPermissions} />}
        />
        <Route
          path="/Settings/Operators/:OperatorId"
          element={<ManageOperators userPermissions={props.userPermissions} />}
        />
        <Route
          path="/Settings/Schools"
          element={<ListSchools userPermissions={props.userPermissions} />}
        />

        <Route
          path="/Settings/UserProvisioning"
          element={<ExecuteCanvasUsers />}
        />
        <Route
          path="/Settings/CourseProvisioning"
          element={<ExecuteCanvasCourses />}
        />
        <Route
          path="/Settings/StudentsCompetency"
          element={<ExecuteStudentsCompentency />}
        />
        <Route
          path="/Settings/CourseAccessLog"
          element={<ExecuteAccessLogs />}
        />
        <Route
          path="/Settings/UserLoginLog"
          element={<ExecuteCanvasUserLogin />}
        />
        <Route path="/Settings/CSLPStudents" element={<UploadEsisStudents />} />
        <Route path="/Settings/CSLPTeachers" element={<UploadEsisTeachers />} />
        <Route
          path="/Settings/DataSync/Courses"
          element={<SyncCourses />}
        ></Route>
        <Route
          path="/Settings/DataSync/CanvasUser"
          element={<SyncUser />}
        ></Route>
        <Route
          path="/Settings/Variables"
          element={<Variables userPermissions={props.userPermissions} />}
        ></Route>
        <Route
          path="/Settings/UsersList"
          element={<UsersList userPermissions={props.userPermissions} />}
        ></Route>
        <Route
          path="/Settings/Roles"
          element={<ListRoles userPermissions={props.userPermissions} />}
        ></Route>
        <Route
          path="/Settings/Roles/:RoleId"
          element={
            <ManageRoles
              setUserPermissions={props.setUserPermissions}
              userPermissions={props.userPermissions}
            />
          }
        ></Route>
        <Route
          path="/Settings/UploadOperatorCSLP"
          element={
            <UploadOperatorCSLP userPermissions={props.userPermissions} />
          }
        />

        <Route
          path="/Settings/Canvas/Sub_Accounts"
          element={<SubAccounts userPermissions={props.userPermissions} />}
        ></Route>

        <Route
          path="/Sessions/DeleteSessions"
          element={<DeleteSessions userPermissions={props.userPermissions} />}
        ></Route>

        <Route
          path="/Settings/DataSync"
          element={<SyncSettings userPermissions={props.userPermissions} />}
        ></Route>

        <Route
          path="/Settings/DataSync/Terms"
          element={<SyncTerms userPermissions={props.userPermissions} />}
        ></Route>

        {/* <Route
          path="/Settings/DataSync/Accounts"
          element={<SubAccounts userPermissions={props.userPermissions} />}
        ></Route> */}
      </Routes>
    </>
  );
};

export default PrivateRoutes;
